var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plans-screen"},[_c('h1',{staticClass:"heading-3 centered"},[_vm._v("Choose Your Plan")]),_c('Plans')],1)}
var staticRenderFns = []

export { render, staticRenderFns }